import { createElement, useCallback } from 'react';
import GenericPopup from './GenericPopup';
import { ModalPresenter } from '@fanduel/cpe-um-bundle/core-modal-presenter/library';
import { PopupConfig, PopupErrorData, PopupTypes } from './types';
import {
  ActionItemTypes,
  NoneActionItem,
} from '@fanduel/cpe-um-bundle/core-modal-presenter/contract';
import {
  addToQueue,
  removeFromQueue,
  removeFromQueueSpecific,
} from '@/store/actions.ts';
import { applyCoreModalsOverrides } from '@/features/Popup/helpers/coreModalOverrides.ts';
import { JackpotWinningAnimation } from '../SWJ/JackpotWinningAnimation/JackpotWinningAnimation';
import { InGameMerchOverlay } from '../InGameMerch/InGameMerchOverlay';
import type { InGameMerchQueueData } from '../InGameMerch/types';
import { POPUP_TYPES } from './constants';

const createJackpotWinStyleActivator = () => {
  const styleActivatorForJackpot = document.createElement('div');
  styleActivatorForJackpot.style.backgroundColor = 'none';
  styleActivatorForJackpot.style.position = 'absolute';
  styleActivatorForJackpot.className = 'jackpot-win-style-activator';
  document.body.append(styleActivatorForJackpot);
};

export const usePopup = () => {
  const hidePopup = useCallback(() => {
    ModalPresenter.dismissAllModals();
    removeFromQueue();
  }, []);

  const showPopup = useCallback(
    (data: PopupConfig, type: PopupTypes, errorData?: PopupErrorData) => {
      const popup = () => {
        if (type === POPUP_TYPES.JACKPOT_WIN) {
          createJackpotWinStyleActivator();
        }
        ModalPresenter.presentModal(
          {
            leadingActionItem:
              ActionItemTypes.NONE as unknown as NoneActionItem,
          },
          type === 'JACKPOT_WIN'
            ? createElement(JackpotWinningAnimation, {
                //TODO: fix this type later
                // @ts-expect-error jackpot win payload is not PopupConfig
                wonJackpot: data,
              })
            : type === 'IN_GAME_MERCH'
              ? createElement(InGameMerchOverlay, {
                  data: data as unknown as InGameMerchQueueData,
                })
              : createElement(GenericPopup, {
                  config: data,
                  type,
                  errorData,
                  onClose: () => hidePopup(),
                }),
        );
        applyCoreModalsOverrides();
      };
      addToQueue({ type, popup });
    },
    [hidePopup],
  );

  const settleJackpotWin = useCallback((type: PopupTypes) => {
    removeFromQueueSpecific({ type });
  }, []);

  const setJackpotWin = useCallback(
    (data: PopupConfig) => {
      showPopup(data, 'JACKPOT_WIN');
    },
    [showPopup],
  );

  const setInGameMerch = useCallback(
    (data: InGameMerchQueueData) => {
      showPopup(data as unknown as PopupConfig, 'IN_GAME_MERCH');
    },
    [showPopup],
  );

  return {
    showPopup,
    hidePopup,
    settleJackpotWin,
    setJackpotWin,
    setInGameMerch,
  };
};
